import { useRoute } from 'vue-router';
import { usePersonStore } from '~/stores/person';

export default defineNuxtPlugin((nuxtApp) => {
    const store = usePersonStore();
    const route = useRoute();
    const user = store?.person?.emails.find((email) => email.primary)?.email;

    // List of routes where Crisp should be hidden
    const hiddenRoutes = ['/buzz/risk-chart', '/buzz/radar'];

    // Check if current route should hide Crisp
    if (hiddenRoutes.includes(route.path)) {
        return; // Don't initialize Crisp on these routes
    }

    (window as any).$crisp = [];
    (window as any).$crisp.push(['safe', true]);
    (window as any).CRISP_WEBSITE_ID = '117215d5-19e8-48b6-8ae0-e3ff96d6f5b8';

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);

    // Set user email when script is loaded
    script.onload = () => {
        if (user) {
            (window as any).$crisp.push(['set', 'user:email', user]);
        }
    };
});
